import Model from 'etap/admin/classes/models/model';


class EntityType extends Model {

    defaults() {
        return {
            id: null,
            name: '',
            title: '',
            type: null,
            built_in_type: null,
            entity_name: null,
            entity_model: null,
            default_form_configuration_id: null,
        }
    }

    casts() {
        return {
            created_at: this.parseDate,
            updated_at: this.parseDate
        }
    }

}

export default EntityType;
